export default "__VITE_ASSET__DNITsDoP__"